import * as React from "react";
import { Route } from "react-router-dom";
import { createBrowserHistory } from "history";
// import MenuIcon from "@material-ui/icons/Menu";

import UserIcon from "mdi-material-ui/AccountGroup";
import RoleIcon from "mdi-material-ui/AccountLock";
import ApiIcon from "mdi-material-ui/Api";
import PermissionIcon from "mdi-material-ui/AlphaPbox";
import AppIcon from "mdi-material-ui/AlphaAbox";
import TenantIcon from "mdi-material-ui/AlphaTbox";
import ForbiddenIcon from "mdi-material-ui/Cancel";

import logo from "./asset/img/logo2.png";
import avatar from "./asset/img/faces/avatar-male.png";

import { App as JApp, Resource, createAuthProvider, createDataProvider } from "jazasoft";

import { TenantHome, CreateTenant, EditTenant, ViewTenant } from "./pages/Tenant";
import { UserHome, UserCreate, UserEdit, UserView } from "./pages/user";
import { AppHome, CreateApps, ViewApp, EditApp } from "./pages/App";
import { RoleHome, RoleCreate, RoleView, RoleEdit } from "./pages/role/index";
import { PermissionHome } from "./pages/Permission";
import { ResourceHome, CreateResource, EditResource, ViewResource } from "./pages/Resource";
import Forbidden from "./pages/Forbidden";

import englishMessage from "./i18n/en";
import theme from "./theme";
import { Role } from "./utils/types";
import Profile from "./pages/Profile";

export const appId = "iam";

const rootUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
// const rootUrl = `http://${window.location.hostname}:8081`;
// const rootUrl = `https://iam-dev.jaza-soft.com`;
const authProvider = createAuthProvider(rootUrl, "Basic Y2xpZW50OnNlY3JldA==", appId);
export const dataProvider = createDataProvider(`${rootUrl}/api`, appId);
const i18nProvider = (locale) => {
  return englishMessage;
};

const customRoutes = [<Route name="profile" exact path="/profile" component={Profile} />];

const resources = [
  { i18nKey: "users", resource: "users" },
  { i18nKey: "roles", resource: "roles" },
  { i18nKey: "resources", resource: "resources" },
  { i18nKey: "permissions", resource: "permissions" },
  { i18nKey: "apps", resource: "apps" },
  { i18nKey: "tenants", resource: "tenants" },
];

const initialState = {
  jazasoft: {
    ui: {
      sidebarOpen: false,
      filterOpen: false,
      optimistic: false,
      viewVersion: 0,
    },
  },
};

const history = createBrowserHistory();

class App extends React.Component {
  render() {
    return (
      <JApp
        appId={appId}
        appName="Auth Server"
        appNameShort="Auth Server"
        authProvider={authProvider}
        dataProvider={dataProvider}
        i18nProvider={i18nProvider}
        resources={resources}
        initialState={initialState}
        customRoutes={customRoutes}
        dashboard={() => {}}
        logo={logo}
        avatar={avatar}
        theme={theme}
        history={history}
      >
        {({ roles = [] }) => {
          let resourceList = [];

          if (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) || roles.includes(Role.ADMIN)) {
            resourceList.push(
              <Resource name="users" resource="users" home={UserHome} create={UserCreate} edit={UserEdit} view={UserView} icon={UserIcon} />
            );
          }
          if (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) || roles.includes(Role.ADMIN)) {
            resourceList.push(
              <Resource name="roles" resource="roles" home={RoleHome} create={RoleCreate} view={RoleView} edit={RoleEdit} icon={RoleIcon} />
            );
          }
          if (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) || roles.includes(Role.ADMIN)) {
            resourceList.push(
              <Resource
                name="resources"
                resource="resources"
                home={ResourceHome}
                create={CreateResource}
                view={ViewResource}
                edit={EditResource}
                icon={ApiIcon}
              />
            );
          }
          if (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) || roles.includes(Role.ADMIN)) {
            resourceList.push(<Resource name="permissions" resource="permissions" home={PermissionHome} icon={PermissionIcon} />);
          }
          if (roles.includes(Role.MASTER)) {
            resourceList.push(
              <Resource
                name="tenants"
                resource="tenants"
                home={TenantHome}
                create={CreateTenant}
                edit={EditTenant}
                view={ViewTenant}
                icon={TenantIcon}
              />
            );
          }
          if (roles.includes(Role.MASTER)) {
            resourceList.push(
              <Resource name="apps" resource="apps" home={AppHome} create={CreateApps} view={ViewApp} edit={EditApp} icon={AppIcon} />
            );
          }
          if (resourceList.length === 0) {
            resourceList.push(<Resource name="forbidden" home={Forbidden} icon={ForbiddenIcon} />);
          }

          return resourceList;
        }}
      </JApp>
    );
  }
}

export default App;
